var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSummVolt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/shopping"
  }, /*#__PURE__*/React.createElement("g", {
    id: "play-cricle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.916 21.8688C26.2941 17.4907 26.2941 10.4029 21.916 6.03598",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.08338 6.03598C1.70528 10.4141 1.70528 17.5019 6.08338 21.8688",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.3047 24.489C11.5028 24.9032 12.7457 25.1049 13.9997 25.1049C15.2538 25.0937 16.4967 24.9032 17.6948 24.489",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.3047 3.41589C11.5028 3.00159 12.7457 2.79999 13.9997 2.79999C15.2538 2.79999 16.4967 3.00159 17.6948 3.41589",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M10.2771 14.8063H12.2236V19.3419C12.2236 20.4003 12.7968 20.6144 13.4961 19.8207L18.2648 14.4032C18.8506 13.7417 18.6049 13.1937 17.7167 13.1937H15.7702V8.65808C15.7702 7.59977 15.1969 7.38559 14.4977 8.17932L9.72902 13.5968C9.14947 14.2646 9.39515 14.8063 10.2771 14.8063Z",
    fill: "#F7DE2A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSummVolt);
export default __webpack_public_path__ + "static/media/icon_summ_volt.d370714f1b12dcdc99642719a6955acf.svg";
export { ForwardRef as ReactComponent };